import React, { useState } from "react";
import {
  Dialog,
  Button,
  Box,
  TextField,
  CircularProgress,
} from "@mui/material";
import styles from "./TaxInvoices.module.css";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";

function EditGst(props: any) {
	const { onCancelEdit, UpdateStudentInvoiceSettings, selectedCountry } = props;
	const auth = useAuthUser();
	const authUser = auth();
	const { invoiceSettings, invoiceSettingUpdateLoading } = useSelector(
		(state: any) => state.appSettings
	);
	const [gstin, setGstin] = useState('');
	const [vat, setVat] = useState('');
	const [gstError, setGstError] = React.useState<boolean>(false);

	const gstNumberRegex =
		/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
	const handleCancel = () => {
		onCancelEdit();
	};

	const handleChange = React.useCallback((event: any, type: string) => {
		if (type === 'gst' && selectedCountry === 'India') {
			setGstin(event.target.value);
			if (!gstNumberRegex.test(event.target.value)) {
				setGstError(true);
			} else {
				setGstError(false);
			}
		} else {
			setVat(event.target.value);
		}
	}, []);

	const handleSaveClick = async (event: any) => {
		event.preventDefault();

		try {
			const body: any = {
				instituteId: authUser?.institute?.[0]?.instituteId,
				nextNumber: invoiceSettings?.nextNumber,
				prefix: invoiceSettings?.prefix,
				isStudentTaxInvoiceEnabled: true,
				taxInvoiceCountry: selectedCountry,
			};

			// Conditionally add either gstNumber or vatNumber based on the selection
			if (selectedCountry === 'India') body.gstNumber = gstin;
			else body.vatNumber = vat;
			if (gstin || vat) UpdateStudentInvoiceSettings(body);
		} catch (error) {}
	};

	React.useEffect(() => {
		if (invoiceSettings?.gstNumber) {
			setGstin(invoiceSettings?.gstNumber);
		} else {
			setVat(invoiceSettings?.vatNumber);
		}
	}, [invoiceSettings]);

	return (
		<Box>
			<div className={styles.editGst}>
				Edit {selectedCountry === 'India' ? 'GSTIN' : 'VAT'}
			</div>
			<div className={styles.gstIn}>
				{selectedCountry === 'India' ? 'GSTIN' : 'VAT'}{' '}
				<span style={{ color: '#EC3939', fontWeight: '400' }}>*</span>
			</div>
			{selectedCountry === 'India' ? (
				<TextField
					sx={{
						width: '80%',
						'& .MuiOutlinedInput-input': {
							padding: '11px',
						},
					}}
					value={gstin}
					error={gstError}
					helperText={gstError ? 'Invalid GST Number' : ''}
					onChange={(e) => handleChange(e, 'gst')}
				/>
			) : (
				<TextField
					sx={{
						width: '80%',
						'& .MuiOutlinedInput-input': {
							padding: '11px',
						},
					}}
					value={vat}
					onChange={(e) => handleChange(e, 'vat')}
				/>
			)}
			<Box sx={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
				<Button
					sx={{
						color: '#BFBFBF',
						border: '1px solid #BFBFBF',
						background: '#FFF',
						textTransform: 'capitalize',
					}}
					variant='outlined'
					onClick={handleCancel}>
					Cancel
				</Button>
				<Button
					sx={{ textTransform: 'capitalize' }}
					variant='contained'
					onClick={handleSaveClick}
					disabled={invoiceSettingUpdateLoading || gstError}>
					{invoiceSettingUpdateLoading ? (
						<CircularProgress size={20} color={'inherit'} />
					) : (
						'Save'
					)}
				</Button>
			</Box>
		</Box>
	);
}
export default EditGst;
